import axios from "axios";

async function FetchData(path) {
    const url = 'https://api.books.exodia.ch/' + path;
    return await axios.get(url);
}

export default FetchData;